<template>
  <el-popover
     v-if="allergenLevel !== 0"
     width="240"
     placement="bottom"
     popper-class="el-popover--allergens-info is-index-list"
    :trigger="trigger"
    :title="$t('label.allergen_information')">

    <div v-if="!_isEmpty(allergens.contains)" class="nuttrema-allergens-info__holder is-contains">
      <h4 class="mt-05 mb-025">{{ $t('label.contains') }}</h4>
      <ul>
        <li v-for="allergen in _get(allergens, 'contains', [])" :title="allergen.tip || ''">
          {{ _get(allergen, 'name') }}
        </li>
      </ul>
    </div>

    <div v-if="!_isEmpty(allergens.may_contain)" class="nuttrema-allergens-info__holder is-may-contain">
      <h4 class="mt-05 mb-025">{{ $t('label.may_contain') }}</h4>
      <ul>
        <li v-for="allergen in _get(allergens, 'may_contain', [])" :title="allergen.tip || ''">
          {{ _get(allergen, 'name') }}
        </li>
      </ul>
    </div>

    <div v-if="!_isEmpty(allergens.contains_no)" class="nuttrema-allergens-info__holder is-contains-no">
      <h4 class="mt-05 mb-025">{{ $t('label.contains_no') }}</h4>
      <ul>
        <li v-for="allergen in _get(allergens, 'contains_no', [])" :title="allergen.tip || ''">
          {{ _get(allergen, 'name') }}
        </li>
      </ul>
    </div>

    <a
       slot="reference"
       class="nuttrema-allergens-info"
      :class="[ `allergen-level-${allergenLevel}` ]"
      @mouseclick="$emit('click')">
      <i class="fas fa-allergies"></i>
    </a>
  </el-popover>
</template>

<script>
import { get, size } from 'lodash';

export default {
  name: 'nuttrema-allergens-info',
  props: {
    allergens: {
      required: false,
      default: null,
    },
    trigger: {
      type: String,
      required: false,
      default: 'click',
    },
  },
  data() {
    return {
      allergenLevel: 0,
    };
  },
  methods: {
    calculateAllergenLevel() {
      const contains = get(this.allergens, 'contains', []);
      const mayContain = get(this.allergens, 'may_contain', []);
      const containsNo = get(this.allergens, 'contains_no', []);

      if (size(contains) > 0) this.allergenLevel = 'contains';
      else if (size(mayContain) > 0) this.allergenLevel = 'may-contain';
      else if (size(containsNo) > 0) this.allergenLevel = 'contains-no';
    },
  },
  created() {
    this.calculateAllergenLevel();
  },
};
</script>

<style lang="scss" scoped>
  @import './nuttrema-allergens-colors';

  .nuttrema-allergens-info {
    color: gray;

    &.allergen-level-contains {
      color: $contains-color;
    }

    &.allergen-level-may-contain {
      color: $may-contain-color;
    }

    &.allergen-level-contains-no {
      color: $contains-no-color;
    }
  }

  .nuttrema-allergens-info__holder {
    padding: 0.25em 0.5em;
    border-radius: 0.5em;
    border: 1px solid gray;
    margin-top: 0.5em;

    &.is-contains {
      color: $contains-color;
      background: $contains-background;
      border-color: $contains-border-color;
    }

    &.is-may-contain {
      color: $may-contain-color;
      background: $may-contain-background;
      border-color: $may-contain-border-color;
    }

    &.is-contains-no {
      color: $contains-no-color;
      background: $contains-no-background;
      border-color: $contains-no-border-color;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/allergens/nuttrema-allergens-info.vue